import { apiConstants } from "../../shared/config";
import work from "./type";
const code = apiConstants.code;
const baseRoute = `${code}.${work.key}_`;
const codeAPI = apiConstants.codeAPI;
const group = work.basePath;

export const type = work.key;
export const panels = {
    parish_interventions_home: {
        menu: {
            route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), "")}.${work.basePath}.home`,
            text: "parish_interventions_home.title",
            icon: "fas fa-map-marked",
        },
        acl: {
            view: "GIM_11000",
        },
    },
    parish_interventions_home_manage: {
        menu: {
            route: `${code}.${group}.home`,
            text: "parish_interventions_home_manage.title",
            icon: "fas fa-building",
        },
        acl: {
            view: "GIM_21000",
        },
    },
    parish_interventions_statuses: {
        menu: {
            route: `${baseRoute}statuses`,
            text: "parish_interventions_statuses.titles",
            icon: "fas fa-info-circle",
        },
        acl: {
            view: "GIM_21031",
            detail: "GIM_21032",
            add: "GIM_21033",
            edit: "GIM_21034",
            delete: "GIM_21035",
        },
        url: {
            getList: `${codeAPI}/${group}/statuses`,
            getShow: `${codeAPI}/${group}/statuses/:id`,
            getCreate: `${codeAPI}/${group}/statuses`,
            getUpdate: `${codeAPI}/${group}/statuses/:id`,
            getDelete: `${codeAPI}/${group}/statuses/:id`,
        },
    },
    parish_interventions_claimants: {
        menu: {
            route: `${baseRoute}claimants`,
            text: "parish_interventions_claimants.titles",
            icon: "fas fa-users",
        },
        acl: {
            view: "GIM_21051",
            detail: "GIM_21052",
            add: "GIM_21053",
            edit: "GIM_21054",
            delete: "GIM_21055",
        },
        url: {
            getList: `${codeAPI}/${group}/claimants`,
            getShow: `${codeAPI}/${group}/claimants/:id`,
            getCreate: `${codeAPI}/${group}/claimants`,
            getUpdate: `${codeAPI}/${group}/claimants/:id`,
            getDelete: `${codeAPI}/${group}/claimants/:id`,
        },
    },
    parish_interventions_types: {
        menu: {
            route: `${baseRoute}types`,
            text: "parish_interventions_types.titles",
            icon: "fas fa-tasks",
        },
        acl: {
            view: "GIM_21041",
            detail: "GIM_21042",
            add: "GIM_21043",
            edit: "GIM_21044",
            delete: "GIM_21045",
        },
        url: {
            getList: `${codeAPI}/${group}/types`,
            getShow: `${codeAPI}/${group}/types/:id`,
            getCreate: `${codeAPI}/${group}/types`,
            getUpdate: `${codeAPI}/${group}/types/:id`,
            getDelete: `${codeAPI}/${group}/types/:id`,
            getLists: `${codeAPI}/${group}/types/lists`,
        },
    },
    parish_interventions_contract_types: {
        menu: {
            route: `${baseRoute}contract_types`,
            text: "parish_interventions_contract_types.titles",
            icon: "fas fa-scroll",
        },
        acl: {
            view: "GIM_21061",
            detail: "GIM_21062",
            add: "GIM_21063",
            edit: "GIM_21064",
            delete: "GIM_21065",
        },
        url: {
            getList: `${codeAPI}/${group}/contract_types`,
            getShow: `${codeAPI}/${group}/contract_types/:id`,
            getCreate: `${codeAPI}/${group}/contract_types`,
            getUpdate: `${codeAPI}/${group}/contract_types/:id`,
            getDelete: `${codeAPI}/${group}/contract_types/:id`,
        },
    },
    parish_interventions_procedure_types: {
        menu: {
            route: `${baseRoute}procedure_types`,
            text: "parish_interventions_procedure_types.titles",
            icon: "fas fa-scroll",
        },
        acl: {
            view: "GIM_21106",
            detail: "GIM_21107",
            add: "GIM_21108",
            edit: "GIM_21109",
            delete: "GIM_21110",
        },
        url: {
            getList: `${codeAPI}/${group}/procedure_types`,
            getShow: `${codeAPI}/${group}/procedure_types/:id`,
            getCreate: `${codeAPI}/${group}/procedure_types`,
            getUpdate: `${codeAPI}/${group}/procedure_types/:id`,
            getDelete: `${codeAPI}/${group}/procedure_types/:id`,
        },
    },
    parish_interventions_unities: {
        menu: {
            route: `${baseRoute}unities`,
            text: "parish_interventions_unities.titles",
            icon: "fas fa-users",
        },
        acl: {
            view: "GIM_21071",
            detail: "GIM_21072",
            add: "GIM_21073",
            edit: "GIM_21074",
            delete: "GIM_21075",
        },
        url: {
            getList: `${codeAPI}/${group}/unities`,
            getShow: `${codeAPI}/${group}/unities/:id`,
            getCreate: `${codeAPI}/${group}/unities`,
            getUpdate: `${codeAPI}/${group}/unities/:id`,
            getDelete: `${codeAPI}/${group}/unities/:id`,
            getLists: `${codeAPI}/${group}/unities/lists`,
            getUsers: `${codeAPI}/${group}/unities/search/user?id=:id&q=:query`,
        },
    },
    parish_interventions_reports: {
        menu: {
            route: `${baseRoute}reports`,
            text: 'parish_interventions_reports.titles',
            icon: 'fas fa-tasks',
        },
        acl: {
            view: "GIM_21093",
            detail: "GIM_21094",
            add: "GIM_21095",
            edit: "GIM_21096",
            delete: "GIM_21097",
            config: "GIM_21091",
            configEdit: "GIM_21092",
        },
        url: {
            getList                 : `${codeAPI}/${group}/reports`,
            getShow                 : `${codeAPI}/${group}/reports/:id`,
            getCreate               : `${codeAPI}/${group}/reports`,
            getUpdate               : `${codeAPI}/${group}/reports/:id`,
            getDelete               : `${codeAPI}/${group}/reports/:id`,

            getScales               : `${codeAPI}/${group}/reports/scales`,
            getConfig               : `${codeAPI}/${group}/reports/settings`,
            getApps                 : `${codeAPI}/${group}/reports/print/apps`,
            getLayouts              : `${codeAPI}/${group}/reports/print/layouts/:appid`,
            getFormats              : `${codeAPI}/${group}/reports/print/formats/:appid`,
            getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
        },
    },
    parish_interventions_notifications: {
        menu: {
            route: `${baseRoute}notifications`,
            text: 'notifications.titles',
            icon: 'fas fa-envelope',
        },
        acl: {
            view: "GIM_21101",
            detail: "GIM_21102",
            add: "GIM_21103",
            edit: "GIM_21104",
            delete: "GIM_21105",
        },
        url: {
            getList                 : `${codeAPI}/${group}/notifications`,
            getShow                 : `${codeAPI}/${group}/notifications/:id`,
            getCreate               : `${codeAPI}/${group}/notifications`,
            getUpdate               : `${codeAPI}/${group}/notifications/:id`,
            getDelete               : `${codeAPI}/${group}/notifications/:id`,
            getLists                : `${codeAPI}/${group}/notifications/lists`,
        },
    },
    parish_interventions_global_types: {
        menu: {
            route: `${baseRoute}global_types`,
            text: "global_types.titles",
            icon: "fas fa-tasks",
        },
        acl: {
            view: "GIM_21021",
            detail: "GIM_21022",
            add: "GIM_21023",
            edit: "GIM_21024",
            delete: "GIM_21025",
        },
        url: {
            getList: `${codeAPI}/gestao/${group}/types`,
            getShow: `${codeAPI}/gestao/${group}/types/:id`,
            getCreate: `${codeAPI}/gestao/${group}/types`,
            getUpdate: `${codeAPI}/gestao/${group}/types/:id`,
            getDelete: `${codeAPI}/gestao/${group}/types/:id`,
            getLists: `${codeAPI}/gestao/${group}/types/lists`,
            getRelationship: `${codeAPI}/gestao/${group}/types/entity/:code`,
        },
    },
    parish_interventions_global_statuses: {
        menu: {
            route: `${baseRoute}global_statuses`,
            text: "global_statuses.titles",
            icon: "fas fa-info-circle",
        },
        acl: {
            view: "GIM_21011",
            detail: "GIM_21012",
            add: "GIM_21013",
            edit: "GIM_21014",
            delete: "GIM_21015",
        },
        url: {
            getList: `${codeAPI}/gestao/${group}/statuses`,
            getShow: `${codeAPI}/gestao/${group}/statuses/:id`,
            getCreate: `${codeAPI}/gestao/${group}/statuses`,
            getUpdate: `${codeAPI}/gestao/${group}/statuses/:id`,
            getDelete: `${codeAPI}/gestao/${group}/statuses/:id`,
            getLists: `${codeAPI}/gestao/${group}/statuses/lists`,
            getRelationship: `${codeAPI}/gestao/${group}/statuses/entity/:code`,
        },
    },
};
